// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-k_gU","advertDetailContacts__header":"c-k_gV"};